import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AssetName, Text, NotificationLayoutItemProjectName, UserName } from '../../../gql/generated/LayoutItems';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetAssignedToYouHeader_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type AssetAssignedToYouHeader_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type AssetAssignedToYouHeader_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type AssetAssignedToYouHeader_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> } } };

export type AssetAssignedToYouHeader_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged' };

export type AssetAssignedToYouHeader_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type AssetAssignedToYouHeader_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type AssetAssignedToYouHeader_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type AssetAssignedToYouHeader_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type AssetAssignedToYouHeader_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type AssetAssignedToYouHeader_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type AssetAssignedToYouHeader_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type AssetAssignedToYouHeader_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type AssetAssignedToYouHeader_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type AssetAssignedToYouHeader_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type AssetAssignedToYouHeader_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type AssetAssignedToYouHeader_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type AssetAssignedToYouHeaderFragment = AssetAssignedToYouHeader_NotificationGroupAccessRequestApproved_Fragment | AssetAssignedToYouHeader_NotificationGroupAccessRequestDenied_Fragment | AssetAssignedToYouHeader_NotificationGroupAccessRequestSubmitted_Fragment | AssetAssignedToYouHeader_NotificationGroupAssetAssignedToYou_Fragment | AssetAssignedToYouHeader_NotificationGroupAssetStatusChanged_Fragment | AssetAssignedToYouHeader_NotificationGroupCommentCreated_Fragment | AssetAssignedToYouHeader_NotificationGroupCommentCreatedShareAccess_Fragment | AssetAssignedToYouHeader_NotificationGroupFileUploaded_Fragment | AssetAssignedToYouHeader_NotificationGroupReplyCreated_Fragment | AssetAssignedToYouHeader_NotificationGroupReplyCreatedShareAccess_Fragment | AssetAssignedToYouHeader_NotificationGroupRequesterAccessRequestApproved_Fragment | AssetAssignedToYouHeader_NotificationGroupRequesterAccessRequestDenied_Fragment | AssetAssignedToYouHeader_NotificationGroupTranscriptCompletedSelf_Fragment | AssetAssignedToYouHeader_NotificationGroupTransferBatchCompleted_Fragment | AssetAssignedToYouHeader_NotificationGroupTransferBatchCompletedSelf_Fragment | AssetAssignedToYouHeader_NotificationGroupUserMentioned_Fragment | AssetAssignedToYouHeader_NotificationGroupUserMentionedShareAccess_Fragment;

export type AssetAssignedToYouHeaderContentFragment = { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> };

export const AssetAssignedToYouHeaderContent = /*#__PURE__*/ gql`
    fragment AssetAssignedToYouHeaderContent on NotificationLayout {
  header {
    ...UserName
    ...Text
    ...AssetName
  }
}
    ${UserName}
${Text}
${AssetName}` as unknown as DocumentNode<AssetAssignedToYouHeaderContentFragment, unknown>;
export const AssetAssignedToYouHeader = /*#__PURE__*/ gql`
    fragment AssetAssignedToYouHeader on NotificationGroup {
  ... on NotificationGroupAssetAssignedToYou {
    content {
      layout {
        ...AssetAssignedToYouHeaderContent
      }
    }
  }
}
    ${AssetAssignedToYouHeaderContent}` as unknown as DocumentNode<AssetAssignedToYouHeaderFragment, unknown>;

        

        
export const useAssetAssignedToYouHeaderFragment = (
  input: string | Omit<UseFragmentOptions<AssetAssignedToYouHeaderFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<AssetAssignedToYouHeaderFragment>({
    fragment: AssetAssignedToYouHeader,
    fragmentName: 'AssetAssignedToYouHeader',
    ...options,
  });
};
  
        
        

        
export const useAssetAssignedToYouHeaderContentFragment = (
  input: string | Omit<UseFragmentOptions<AssetAssignedToYouHeaderContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<AssetAssignedToYouHeaderContentFragment>({
    fragment: AssetAssignedToYouHeaderContent,
    fragmentName: 'AssetAssignedToYouHeaderContent',
    ...options,
  });
};
  
        